import React, { Component } from "react";
import Layout from "../components/layout";
import { Link } from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import { Row, Col, Container } from "react-bootstrap";

import {Animated} from "react-animated-css";

import smallTeams from "../../static/images/about/small_teams.svg";
import transparency from "../../static/images/about/transparency.svg";
import dataSecurity from "../../static/images/about/data_security.svg";
import ipOwnership from "../../static/images/about/ip_ownership.svg";
import aiBenefit from "../../static/images/about/ai_benefit.svg";
import socialBenefit from "../../static/images/about/social_benefit.svg";
import environmentImpact from "../../static/images/about/environmental_impact.svg";
import employmentEquality from "../../static/images/about/employment_equality.svg";
import education from "../../static/images/about/education.svg";
import philosophy from "../../static/images/about/philosophy.svg";
import aboutHeaderImage from "../../static/images/about/about_graphics_resized.png";

import '../styles/style.scss';

import { assignActiveElementNew, visibilityObject, changeSlideInClass } from "../utilities/elementUtilities";


class About extends Component {

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);

    this.handleScroll();

  }

  handleScroll = () => {

    // var sectionList = [
    //   document.getElementById('our-philosophy'),
    //   document.getElementById('values-section'),
    // ];
    // assignActiveElement(sectionList);

    var sectionList = [
      visibilityObject(document.getElementById('our-philosophy')),
      visibilityObject(document.getElementById('values-section')),
    ];
    assignActiveElementNew(sectionList);


    changeSlideInClass();
  }

  render() {
    return(  
      <Layout footerMargin={false} layoutClassName="values-page">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="v-ensure-your-success"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="our-philosophy"
                  spy={true}
                  smooth={true}
                  offset={-85}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="values-section"
                  spy={true}
                  smooth={true}
                  offset={-300}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
          </ul>
        </div>
        <div id="values-container" className="full-container container">
          <section id="v-ensure-your-success" className="section values-heading full first">
            <Row>
              <Col sm="12" lg="6" className="values-heading-img-holder heading-img-holder">
                <img src={aboutHeaderImage} alt="check" className="" />
              </Col>
              <Col sm="12" lg="6" className="values-heading-caption-column">
                <Row className="values-heading-caption">
                  <Col sm="12" className="values-heading-header">
                  <p className="header-right">Our mission is to create meaningful jobs for millions of people, by teaching them how to build human-centered AI products.</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </section>
        </div>
        <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
          <section className="section values full" id="our-philosophy">
            <Container>
              <Row>
                <Col xs={12} md={5} className="our-philosophy-img-holder">
                  <img src={philosophy} alt="Our Philosophy" />
                </Col>
                <Col xs={12} md={7} className="our-philosophy-text">
                  <h2 className="heading">Our Philosophy</h2>
                  <p className="subheading">In the age of software, innovative organizations invest significantly to build their own proprietary digital products that offer a great User Experience (UX) and leverage Artificial Intelligence (AI).</p>
                  <p className="subheading">This omnipresent AI software layer opens a new dimension where operations, products and services merge into one user experience. Whether the user is an employee, another business, or a customer, the cost, speed, and ease of utilizing the AI layer becomes the most important differentiators between winners and losers in globally competitive marketplaces.</p>
                  <p className="subheading">Off the shelf software does not differentiate you, nor does it provide the integration, flexibility, and affordability you need to succeed. We believe the only way to win is through bespoke software where you own the IP and have the ability to prioritize new features.</p>
                  <p className="subheading">However, building teams that build AI with great UX is incredibly hard. Our value proposition to you is that we provide you with teams that will design, build, support and maintain those products for you.</p>
                </Col>
              </Row>
            </Container>
          </section>
        </Animated>
        <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true}>
          <section className="section values values-section" id="values-section">
            <Container fluid={true}>
              <Row>
                <Col xs={12} className="values-section-header" id="values-header">
                  <p>We recognize AI will change the world. Our values exist to serve our clients and benefit humanity.</p>
                </Col>
              </Row>
              {/* <section>
                <p>We recognize AI will change the world. Our values exist to serve our clients and benefit humanity.</p>
              </section> */}
              <Row>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value firstRow">
                    <img src={smallTeams} alt="Small Teams" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={smallTeams} alt="Small Teams" className="image" />
                        <div className="heading">Small Teams</div>
                      </div>
                      <p>We believe in small teams of 3-7 people to drive speed.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value firstRow">
                    <img src={transparency} alt="Transparency" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={transparency} alt="Transparency"  className="image"/>
                        <div className="heading">Transparency</div>
                      </div>
                      <p>Full transparency is accomplished through daily work logs and 24-7 access to Product Managers.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value firstRow">
                    <img src={dataSecurity} alt="Data Security" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={dataSecurity} alt="Data Security" className="image values-image-smaller" />
                        <div className="heading">Data Security</div>
                      </div>
                      <p>We will not have access to your data and will provide the scripts necessary to fully integrate the product.</p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value secondRow">
                    <img src={ipOwnership} alt="IP Ownership" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={ipOwnership} alt="IP Ownership" className="image values-image-smaller" />
                        <div className="heading">IP Ownership</div>
                      </div>
                      <p>All IP created with bld.ai is the sole property of our clients. We do not charge for licensing.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value secondRow">
                    <img src={aiBenefit} alt="AI for the benefit of humanity" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={aiBenefit} alt="AI for the benefit of humanity" className="image" />
                        <div className="heading">AI for the benefit of humanity</div>
                      </div>
                      <p>AI will fundamentally change the way we live. bld.ai is committed to ensuring that our products benefit humanity and properly distribute power. We are aligned with OpenAI charter: <a href="https://openai.com/charter/" target="_blank" rel="noopener noreferrer">https://openai.com/charter/</a>.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value secondRow">
                    <img src={socialBenefit} alt="Social Benefit" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={socialBenefit} alt="Social Benefit" className="image" />
                        <div className="heading">Social benefit</div>
                      </div>
                      <p>We believe in the age of software. With AI we will spend less time on mundane jobs and more time on jobs that prioritize creativity, empathy, and strategic thinking. </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value lastRow">
                    <img src={environmentImpact} alt="Environmental impact" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={environmentImpact} alt="Environmental impact" className="image" />
                        <div className="heading">Environmental impact</div>
                      </div>
                      <p>Our teams are distributed and enable people to work from home to monitor and make better use of their assets resulting in less natural resource usage and waste.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value lastRow">
                    <img src={employmentEquality} alt="Employment equality" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={employmentEquality} alt="Employment equality" className="image" />
                        <div className="heading">Employment equality</div>
                      </div>
                      <p>We believe in fair compensation that attracts the best talent and therefore have agreed upon fair skill-based rates with our employees and contractors, and to these we add a fee reflective of our low overhead.</p>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={12} lg={3} className="valueColumn">
                  <div className="value lastRow">
                    <img src={education} alt="Education for all" className="image-sm" />
                    <div className="content">
                      <div className="header">
                        <img src={education} alt="Education for all" className="image" />
                        <div className="heading">Education for all</div>  
                      </div>
                      <p>We donate back a portion of our proceeds to building apps which support children’s STEM education, provides adults the ability to retool their skillsets, and allows the elderly the means by which to maintain their cognition.</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </Animated>
      </Layout>
    );
  }
}

export default (About);
